export default __webpack_public_path__ + "static/media/default.79f9b42df021705846699aa6d176e8c4.svg";